import ReactDOM from "react-dom/client";
import "./index.css";
import "./initial";
import App from "./entry/Register";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />
);
